<div
  [class]="class()"
  (pointerdown)="onPointerDown($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerCancel($event)"
>
  @for (image of images(); track image; let idx = $index) {
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <img
      [ngSrc]="image"
      alt=""
      [class]="galleryClass()"
      [class.hidden]="slideIndex() !== idx + 1"
      width="666"
      height="444"
      (click)="onImageClick()"
    />
  }

  @if (totalSlides() > 1) {
    <button
      id="previous-image"
      type="button"
      aria-label="Previous image"
      class="absolute cursor-pointer top-[50%] w-auto -mt-[1.375rem] p-4 text-white font-bold text-[18px] transition-colors rounded-r-lg select-none bg-gray-900/40 hover:bg-gray-900/60"
      (click)="changeSlide(-1)"
    >
      &#10094;
    </button>
    <button
      id="next-image"
      type="button"
      aria-label="Next image"
      class="absolute cursor-pointer top-[50%] right-0 w-auto -mt-[1.375rem] p-4 text-white font-bold text-[18px] transition-colors rounded-l-lg select-none bg-gray-900/40 hover:bg-gray-900/60"
      (click)="changeSlide(1)"
    >
      &#10095;
    </button>

    <div class="absolute bottom-0 p-2 flex gap-2">
      <button
        type="button"
        class="rounded-md px-2.5 py-1.5 sm:px-2 sm:py-1 text-sm sm:text-xs justify-evenly font-semibold bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-900 cursor-pointer dark:disabled:bg-gray-800/20 flex items-center gap-1 w-27"
        (click)="openGalleryClicked.emit(slideIndex())"
      >
        <svg viewBox="0 -960 960 960" class="fill-gray-900 dark:fill-gray-100 h-7 w-7">
          <path
            d="M363.08-406.15h373.84L612.77-569.23l-95.08 121.54-62.77-77.69-91.84 119.23ZM322.31-260Q292-260 271-281q-21-21-21-51.31v-455.38Q250-818 271-839q21-21 51.31-21h455.38Q808-860 829-839q21 21 21 51.31v455.38Q850-302 829-281q-21 21-51.31 21H322.31Zm0-60h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-455.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H322.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v455.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85Zm-140 200Q152-120 131-141q-21-21-21-51.31v-515.38h60v515.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h515.38v60H182.31ZM310-800v480-480Z"
          />
        </svg>

        {{ slideIndex() }} / {{ totalSlides() }}
      </button>

      <ng-content />
    </div>
  }
</div>
